import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { showPopup } from "../../../redux/action-creaters/popup";
import { popupTypes } from "../../../redux/reducers/popupReducer";
import styles from "./index.module.scss";
import { formatPrice, getProductsPhotos } from "../../../utils";
import Loader from "../../common/loader";
import {
  fetchElectricsProducts,
  formatSelectedElectrics,
} from "../../../utils/electricsSelection";

export default function SelectElectrics() {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.popup);
  const [electricsProducts, setElectricsProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const isFarkop = String(data.product.IBLOCK_SECTION_ID) === "635";

  useEffect(() => {
    const fetchElectrics = async () => {
      try {
        setIsLoading(true);

        const products = await fetchElectricsProducts(data.product);
        setElectricsProducts(
          products.filter((product) => product.CATALOG.AVAILABLE),
        );
      } catch (error) {
        console.error("Error fetching electrics:", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (data?.product) {
      fetchElectrics();
    } else {
      setIsLoading(false);
    }
  }, [data]);

  const handleSelect = (product) => {
    const selected = formatSelectedElectrics(product);
    if (data?.isDetail) {
      dispatch(showPopup(popupTypes.none));
      data.onSelect(selected);
    } else {
      dispatch(
        showPopup(popupTypes.installCalculator, {
          product: data.product,
          electric: selected,
        }),
      );
    }
  };

  return (
    <div className={styles.Wrapper}>
      <h2 className={styles.Title}>
        {isFarkop ? "Выбрать электрику" : "Выбрать фаркоп"}
      </h2>
      {/* eslint-disable-next-line no-nested-ternary */}
      {isLoading ? (
        <div className={styles.Loader}>
          <Loader />
        </div>
      ) : electricsProducts.length === 0 ? (
        <div className={styles.Empty}>
          {isFarkop ? "Электрика не найдена" : "Фаркоп не найден"}
        </div>
      ) : (
        <div className={styles.Products}>
          {electricsProducts.map((product) => {
            const photos = getProductsPhotos(product);
            const imageUrl = photos?.[0]?.small;
            const price = product.CATALOG?.MIN_PRICE || 0;

            return (
              <div
                key={product.CODE || product.ID}
                className={styles.Product}
                onClick={() => handleSelect(product)}
              >
                <div className={styles.ProductImage}>
                  {imageUrl ? (
                    <img
                      src={imageUrl}
                      alt={product.NAME}
                      onError={(e) => {
                        e.target.style.display = "none";
                      }}
                    />
                  ) : (
                    <div className={styles.ProductImagePlaceholder}>
                      <svg
                        width="60"
                        height="60"
                        viewBox="0 0 60 60"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="1"
                          y="1"
                          width="58"
                          height="58"
                          rx="4"
                          stroke="#D2D6DB"
                          strokeWidth="1"
                        />
                      </svg>
                    </div>
                  )}
                </div>
                <div className={styles.ProductName}>
                  {/* eslint-disable-next-line no-use-before-define */}
                  {getName(product.NAME)}
                </div>
                <div className={styles.ProductPrice}>
                  Цена: {formatPrice(price)} руб.
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

function getName(name = "") {
  const [text, model = ""] = name.split(" для ");
  if (!model) {
    return name;
  }
  // eslint-disable-next-line no-unused-vars
  const [_, dopInfo] = model.split(" (") || "";
  return `${text} ${dopInfo ? ` (${dopInfo}` : ""}`;
}
